import React from 'react';
import OtpInput from './OtpInput';
import { useGetOtpModalInputRefs } from '../../../../../stores/otpModal.store';
import { useGetLangDirectionApp } from '../../../../../stores/app.store';

type TypeOtpInputs = {
    onOtpCodeChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
}

const OtpInputs: React.FC<TypeOtpInputs> = ({ onOtpCodeChange }) => {

    const dirLang = useGetLangDirectionApp();
    const refs = useGetOtpModalInputRefs();

    const isRtl = dirLang === 'rtl';
    
    return (
        <div style={{ display: 'flex', gap: '0.25rem', justifyContent: 'center', flexDirection: isRtl ? 'row-reverse' : 'row', marginTop: '16px' }}>
            <OtpInput ref={refs[0]} onChange={(e) => onOtpCodeChange(e, 0)} />
            <OtpInput ref={refs[1]} onChange={(e) => onOtpCodeChange(e, 1)} />
            <OtpInput ref={refs[2]} onChange={(e) => onOtpCodeChange(e, 2)} />
            <OtpInput ref={refs[3]} onChange={(e) => onOtpCodeChange(e, 3)} />
            <OtpInput ref={refs[4]} onChange={(e) => onOtpCodeChange(e, 4)} />
            <OtpInput ref={refs[5]} onChange={(e) => onOtpCodeChange(e, 5)} />
        </div>
    );
}

export default OtpInputs;